import { ListResponse, PostModel } from "common/models/baseModel";
import { IDropdownModel, INameValueModel } from "common/models/IDropdownModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";

import { createQueryKeys } from "@lukemorales/query-key-factory";

import { instituteView } from "../types/instituteView";
import { IInstitute, IInstituteGridFilter, IInstituteGridModel } from "./types";

export const institute = createQueryKeys("institute", {
  list: (postModel: PostModel<IInstituteGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<ListResponse<IInstituteGridModel>>(
        endpoints.institute.list,
        postModel
      ),
  }),
  get: (id: number) => ({
    queryKey: [id],
    queryFn: () => api.get<IInstitute>(`${endpoints.institute.get}/${id}`),
  }),
  view: (id: number) => ({
    queryKey: [id],
    queryFn: () => api.get<instituteView>(`${endpoints.institute.view}/${id}`),
  }),
  useAllInstituteValue: {
    queryKey: null,
    queryFn: () => api.get<IDropdownModel[]>(`${endpoints.institute.useAllInstituteValue}`),
  },
  communityWiseValues: {
    queryKey: null,
    queryFn: () =>
      api.get<IDropdownModel[]>(`${endpoints.institute.communityWiseValues}`),
  },
  valuesByCommunityId: (communityID: number) => ({
    queryKey: [communityID],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.institute.valuesByCommunityId}/${communityID}`
      ),
  }),
  useProgramByInstituteValues: (id: number) => ({
    queryKey: [id],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.institute.useProgramByInstituteValues}/${id}`
      ),
  }),
  useCourseRolebyInstituteValues: (id: number) => ({
    queryKey: ["courseRolebyInstituteValues", id],
    queryFn: () =>
      api.get<INameValueModel[]>(
        `${endpoints.institute.useCourseRolebyInstituteValues}/${id}`
      ),
  }),
  // universityValues: {
  //   queryKey: null,
  //   queryFn: () =>
  //     api.get<IDropdownModel[]>(`${endpoints.institute.univserityValues}`),
  // },
});
